import Head from "next/head";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { useUser } from "@/context/UserContext";
import { AuthRedirecting } from "@/components/auth/AuthLayout";

/** "/" sends you to the dashboard or to log in, but only once the session check has finished. */
export default function Home() {
  const { user, loading } = useUser();
  const router = useRouter();

  useEffect(() => {
    if (loading) return;
    router.replace(user ? "/dashboard" : "/login");
  }, [user, loading, router]);

  return (
    <>
      <Head>
        <title>Spidra</title>
        <meta name="description" content="Scrape any website with real browser actions and AI prompts" />
      </Head>
      <AuthRedirecting />
    </>
  );
}
